/* src/app/components/payroll/timesheets/timesheets-add-entries/timesheets-add-entries.component.css */
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  outline: 1px solid red;
  outline-offset: 1px;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.ant-checkbox-wrapper.error-class {
  border: 1px solid red !important;
}
.timesheet-table {
  table-layout: fixed;
  width: 100%;
  font-size: 12px;
}
.timesheet-table .ant-select {
  font-size: 12px !important;
}
td,
th {
  padding: 5px !important;
}
.tooltip-container {
  margin-right: 5px !important;
}
tr {
  vertical-align: top !important;
}
.mobile-timesheet-card details {
  border: 1px solid #e6e6e6;
  padding: 0px 10px;
  border-radius: 6px;
  background: #fff;
}
.mobile-summary {
  cursor: pointer;
  padding: 6px 0;
}
.mobile-summary .mobile-actions ppl-button {
  margin-left: 6px;
}
.mobile-card-body label {
  display: block;
  margin-bottom: 4px;
}
.mobile-card-body .ppl-select,
.mobile-card-body input,
.mobile-card-body p-calendar {
  width: 100%;
}
@media (max-width: 575.98px) {
  .mobile-summary .fw-bold {
    font-size: 14px;
  }
}
.meal-break-intro {
  margin: 0 0 16px 0;
  color: #444;
  font-size: 13px;
}
.meal-break-entry {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0;
  margin-bottom: 16px;
  background: #fff;
  overflow: hidden;
}
.meal-break-entry__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f5fafa;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  font-weight: 600;
}
.meal-break-entry__header .day {
  color: #555;
  font-weight: 500;
}
.meal-break-entry__header .sep {
  color: #bbb;
}
.meal-break-entry__body {
  padding: 4px 14px 12px 14px;
}
.meal-break-section + .meal-break-section {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #eee;
}
.meal-break-existing-notice {
  margin-bottom: 10px;
  padding: 8px 12px;
  font-size: 13px;
}
.meal-break-errors {
  margin: 12px 0 0 0;
  padding: 8px 12px;
  font-size: 13px;
}
.meal-break-errors > div + div {
  margin-top: 4px;
}
.meal-break-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}
.meal-break-row__label {
  flex: 1 1 auto;
  font-size: 13px;
  font-weight: 500;
  color: #222;
}
.meal-break-row__label .required {
  color: #d4380d;
}
.meal-break-row__control {
  flex: 0 0 auto;
  min-width: 140px;
  text-align: right;
}
.meal-break-row__control nz-radio-group label {
  margin-right: 12px;
}
.meal-break-row__control nz-radio-group label:last-child {
  margin-right: 0;
}
.meal-break-sub {
  padding: 10px 12px 12px 12px;
  margin: 4px 0 8px 0;
  background: #fafafa;
  border-left: 3px solid #a8e4e1;
  border-radius: 4px;
}
.meal-break-times {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.meal-break-times__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.meal-break-times__field label {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}
.meal-break-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}
@media (max-width: 575.98px) {
  .meal-break-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .meal-break-row__control {
    width: 100%;
    text-align: left;
  }
}
/*# sourceMappingURL=timesheets-add-entries.component-OFVYAIYL.css.map */
